/**
 * Lightweight cross-component signal used by CompanySwitcher to tell
 * useUnsavedChangesGuard that a company-switch navigation has been confirmed
 * and the guard's cleanup should NOT call history.go(-1).
 *
 * Module-level state is acceptable here because:
 * - This only runs in the browser (client component guard).
 * - The flag is read and immediately reset inside the guard cleanup, so it
 *   never persists beyond the cleanup turn.
 * - Using a Jotai atom or React ref would require threading state through
 *   component trees that are unrelated to each other.
 */
let _bypassed = false;

export const setCompanySwitchGuardBypass = (value: boolean) => {
    _bypassed = value;
};

export const getCompanySwitchGuardBypass = () => _bypassed;
